import { Header } from "./header";
import ThumbnailReviewer from "./thumbnail-reviewer";

export default function Home() {
  return (
    <main className="min-h-screen bg-gray-50">
      <Header />
      <div className="container mx-auto px-4 py-4">
        <ThumbnailReviewer />
      </div>
    </main>
  );
}
